import React, { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';
import { translations, fallbackLang } from '../i18n/translations';

const LanguageCtx = createContext(null);

const getInitialLang = () => {
  try {
    const saved = localStorage.getItem('app.lang');
    if (saved) return saved;
  } catch {}
  if (typeof navigator !== 'undefined') {
    const nav = (navigator.language || navigator.userLanguage || 'fr').slice(0, 2).toLowerCase();
    return ['fr', 'en'].includes(nav) ? nav : 'fr';
  }
  return 'fr';
};

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(getInitialLang);

  useEffect(() => {
    try { localStorage.setItem('app.lang', lang); } catch {}
    try { document.documentElement.setAttribute('lang', lang); } catch {}
  }, [lang]);

  const toggleLang = useCallback(() => {
    setLang(prev => (prev === 'fr' ? 'en' : 'fr'));
  }, []);

  const t = useCallback((key) => {
    const dict = translations[lang] || {};
    const fb = translations[fallbackLang] || {};
    return (dict[key] ?? fb[key] ?? key);
  }, [lang]);

  const value = useMemo(() => ({ lang, setLang, toggleLang, t }), [lang, toggleLang, t]);

  return <LanguageCtx.Provider value={value}>{children}</LanguageCtx.Provider>;
}

export function useLanguage() {
  const ctx = useContext(LanguageCtx);
  if (!ctx) throw new Error('useLanguage must be used within <LanguageProvider>');
  return ctx;
}

export function useTranslation() {
  const { t, lang, setLang, toggleLang } = useLanguage();
  return { t, lang, setLang, toggleLang };
}

